import { Component, OnInit } from '@angular/core';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { FormBuilder,FormGroup,Validators } from '@angular/forms';
import { Router,ActivatedRoute } from '@angular/router';
import {AngularFirestore} from '@angular/fire/firestore';
import { EcomicService } from '../../service/comics/ecomic.service';
import { Series } from './../../models';
import { AuthService } from './../../service/auth.service';
import 'rxjs/add/operator/map';
@Component({
  selector: 'app-e-novel-series-add',
  templateUrl: './e-novel-series-add.component.html',
  styleUrls: ['./e-novel-series-add.component.css']
})
export class ENovelSeriesAddComponent implements OnInit {
  novelseriesForm:FormGroup;
  user: any;
  status: any = true;
  id: any;
  loading: any = false;

  thumbnail_image: File;
  cover_image: File;
  thumbnail_image_url: any;
  cover_image_url: any;
  coverimageerror: any = false;
  thumbnailimageerror: any = false;

     constructor(private form:FormBuilder, 
      private auth: AuthService,private router:Router,private comics: EcomicService,private afs:AngularFirestore,private route:ActivatedRoute) { 
      if (this.route.firstChild){
        this.route.firstChild.params.subscribe(params => {
          this.id = params['id'];
          if (this.id) {
            this.status = false;
            this.comics.getsinglenovel(this.id, 'Enovelseries').then(data => {
              // const admindata = data.valueChanges();
              data.subscribe(singlenovel => {
                console.log(singlenovel);

                const singleadmin = singlenovel;
                this.novelseriesForm.get('title').setValue(singleadmin['title']);
                this.novelseriesForm.get('description').setValue(singleadmin['description']);
                this.novelseriesForm.get('seo_title').setValue(singleadmin['seo_title']);
                this.novelseriesForm.get('seo_description').setValue(singleadmin['seo_description']);
                this.novelseriesForm.get('seo_keyword').setValue(singleadmin['seo_keyword']);
                this.novelseriesForm.get('status').setValue(singleadmin['status']);
                this.cover_image_url = singleadmin['cover_image'];
                 this.thumbnail_image_url = singleadmin['thumbnail_image'];
                 this.status = true;
              });
            });
          }
        });
      }
   }

    async ngOnInit() {
       
     this.novelseriesForm = this.form.group({
      title:['',[Validators.required]],
      description:['',[Validators.required]],
      thumbnail_image:['',[]],
      cover_image:['',[]],
      seo_title:['',[Validators.required]],
      seo_description:['',[Validators.required]],
      seo_keyword:['',[Validators.required]],
      status:['Inactive',[Validators.required]],
     
     });
     
    if (!this.id) {
      this.auth.getuser().then(userdetails => {
        this.user = userdetails;
      });
    }
  }
     
  async addseries(value, valid) {
    this.loading = true;
     if (valid) {
       const series: Series = {
         title: value.title,
         description: value.description,
         seo_title: value.seo_title,
         seo_description: value.seo_description,
         seo_keyword: value.seo_keyword,
         status: value.status,
       
       };
       try {
         if (this.id) {
          let thumbnail;
          let coverimage;
          if (this.cover_image) {
            coverimage = await this.auth.uploadimage('comic/cover/', this.cover_image, false);
            series.cover_image = coverimage['Location'];
          }
          // Checking if the thumbnail image is changed if changed the update the image in sapces and also db.
          if (this.thumbnail_image) {
            thumbnail = await this.auth.uploadimage('comic/thumbnail/', this.thumbnail_image, false);
            series.thumbnail_image = thumbnail['Location'];
          }
           const document = await this.afs.doc(`/Enovelseries/${this.id}`);
           const update = await document.update(series);
           this.router.navigate(['/novel-series']);
         } else {
          if (!this.thumbnail_image) { this.thumbnailimageerror = true; this.loading = false; return false; }
          if (!this.cover_image) { this.coverimageerror = true; this.loading = false; return false; }
          // uploading the images to the spaces and getting the uoloaded location
          const thumbnail = await this.auth.uploadimage('comic/thumbnail/', this.thumbnail_image, false);
          const coverimage = await this.auth.uploadimage('comic/cover/', this.cover_image, false);
           series.thumbnail_image = thumbnail['Location'];
           series.cover_image = coverimage['Location']; 
           series.admin = this.user.uid;
           series.addedby = this.user.username;
           series.createdAt =  new Date();
           series.date = new Date().toString();
           const eseriesdata = await this.afs.collection('Enovelseries').add(series);
           const esid = eseriesdata.id;
           const id = await this.afs.doc(`/Enovelseries/${esid}`).update({id: esid});
           this.router.navigate(['/novel-series']);
         }
         } catch (error) {
           this.loading = false;
         console.log(error);
       }
     } else {
       console.log('error');
     }
   }
    
  
     changeListner1(event) {
      this.thumbnailimageerror = false
      if (event.target.files && event.target.files[0]) {
        this.thumbnail_image = event.target.files[0];
        var reader = new FileReader();
  
        reader.onload = (event:any) => {
          this.thumbnail_image_url = event.target.result;
        }
  
        reader.readAsDataURL(event.target.files[0]);
      }
    }

    changeListner2(event) {
      this.coverimageerror = false;
      if (event.target.files && event.target.files[0]) {
        this.cover_image = event.target.files[0];
        var reader = new FileReader();
  
        reader.onload = (event:any) => {
          this.cover_image_url = event.target.result;
        }
  
        reader.readAsDataURL(event.target.files[0]);
      }
    }

}



// WEBPACK FOOTER //
// ./src/app/E-novels/e-novel-series-add/e-novel-series-add.component.ts